import { config } from '../config';
import { addAuthHeader } from './auth';

export async function sendHumanDetectionImage(imageBlob: Blob) {
  const formData = new FormData();
  formData.append('image', imageBlob, 'frame.jpg');

  const headers = await addAuthHeader({}); // Auth only, no Content-Type here (FormData handles it)

  const response = await fetch(`${config.backendUrl}/detect-human`, {
    method: 'POST',
    headers,
    body: formData
  });

  if (!response.ok) {
    throw new Error('Failed to send image');
  }

  return await response.json();
}
